import React from 'react';
import { useSecureShoppingImages } from 'hooks/useSecureShoppingImages';
import { LazyImgDpr } from '../../LazyImgDpr/LazyImgDpr';
import { TextContainer } from './common';
import { DigicertLogo } from '../../DigicertLogo/DigicertLogo';

export const SecureShopping: React.FC<{}> = () => {
  const { secureShoppingSmallIcons } = useSecureShoppingImages();
  return (
    <>
      <TextContainer>
        Your purchases are protected by encrypted security systems that keep your personal data and payment information
        safe and secure.
      </TextContainer>
      <div className="icons-container">
        <DigicertLogo />
        <div className="icons-small">
          {secureShoppingSmallIcons.map(props => (
            <LazyImgDpr className="small-icon" {...props} />
          ))}
        </div>
      </div>
      <style jsx>{`
        .big-icon {
          height: 40px;
          width: 69px;
        }
        .small-icon {
          height: 17px;
        }
        .icons-container {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          height: 40px;
        }
        .icons-small {
          display: grid;
          align-items: center;
          justify-content: space-between;
          grid: 1fr 1fr / 1fr 1fr;
          grid-gap: 0 10px;
          margin-left: 5px;
        }
      `}</style>
    </>
  );
};
